<script>
    export let fields = [];
    export let value = {};
    function prevent(e) {
        e.preventDefault();
    }

   function binding(event,name) {
        let val = event.target.value;
        if(val === ''){
            val = null;
        }
        value[name] = val;
        //console.log(value[name])
    }
</script>

<style>
    form {
        display: flex;
        flex-direction: column;
    }

    label {
        text-align: left;
        font-weight: bold;
    }

    input {
        padding: 0.2em 0.3em 0.3em 0.5em;
        border: 1px solid black;
        background-color: white;
        font-size: 14px;
        margin-bottom: 0.5em;
        border-radius: 4px;
    }

    textarea {
        border: 1px solid black;
        min-height: 220px!important;
        padding: 0.2em 0.3em 0.3em 0.5em;
        border-radius: 4px;
    }
</style>

<form on:submit={prevent}>
    {#each fields as f}
        <label for="">{f.label}</label>
        {#if f.type !== 'textarea'}
            <input type={f.type} on:input={(e) => (binding(e,f.name))}>
        {:else}
            <textarea on:input={(e) => (binding(e,f.name))} />
        {/if}
    {/each}
</form>